module.exports = __webpack_public_path__ + "static/media/GuideToFileHandling.def963b5.png";